import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pdf-link__link" }

import {
  mapModifires,
  mergeModifires,
  type typeModifires,
} from "@/components/utils/modifires";
import { InlineLink } from "@/components/modules";
import { withDefaults, defineOptions } from "vue";

interface Props {
  modifires?: typeModifires;
  align?: "left" | "center" | "right";
  href?: string;
  download?: string;
  target?: "_self" | "_blank" | "_parent" | "_top";
}

export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'pdf-link',
  props: {
    modifires: { type: [String, Array, Boolean] },
    align: {},
    href: {},
    download: {},
    target: {}
  },
  setup(__props: any) {

const props = __props;





const componentClass = () =>
  mapModifires(
    "pdf-link",
    mergeModifires(props.modifires, props.align && `align-${props.align}`)
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(componentClass())
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(InlineLink), {
        onClick: _ctx.$attrs.onClick,
        href: _ctx.href,
        download: _ctx.download,
        target: _ctx.target
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["onClick", "href", "download", "target"])
    ])
  ], 2))
}
}

})